/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseIdentPublicApi } from '../../base-api';
export type CreateTenantMutationVariables = Types.Exact<{
  tenant: Types.CreateTenantInput;
}>;


export type CreateTenantMutation = { __typename: 'Mutation', createTenant: { __typename: 'TenantResponseType', tenantId: string, existingUser?: boolean } };

export type ConfirmUserMutationVariables = Types.Exact<{
  input: Types.ConfirmUserInput;
}>;


export type ConfirmUserMutation = { __typename: 'Mutation', confirmUser?: any };

export type ForgotPasswordMutationVariables = Types.Exact<{
  username: Types.Scalars['String']['input'];
  appClientId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ForgotPasswordMutation = { __typename: 'Mutation', forgotPassword: { __typename: 'ForgotPasswordResponseType', isPasswordReset: boolean, nextStep: { __typename: 'ForgotPasswordNextStepType', resetPasswordStep: string } } };

export type ReadIdentityProviderByEmailMutationVariables = Types.Exact<{
  appClientId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email: Types.Scalars['String']['input'];
}>;


export type ReadIdentityProviderByEmailMutation = { __typename: 'Mutation', readIdentityProviderByEmail: { __typename: 'IdentityProviderResponseType', identityProviderId: string } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const CreateTenantDocument = new TypedDocumentString(`
    mutation CreateTenant($tenant: CreateTenantInput!) {
  __typename
  createTenant(tenant: $tenant) {
    __typename
    tenantId
    existingUser
  }
}
    `);
export const ConfirmUserDocument = new TypedDocumentString(`
    mutation ConfirmUser($input: ConfirmUserInput!) {
  __typename
  confirmUser(input: $input)
}
    `);
export const ForgotPasswordDocument = new TypedDocumentString(`
    mutation ForgotPassword($username: String!, $appClientId: String) {
  __typename
  forgotPassword(input: {username: $username, appClientId: $appClientId}) {
    __typename
    isPasswordReset
    nextStep {
      __typename
      resetPasswordStep
    }
  }
}
    `);
export const ReadIdentityProviderByEmailDocument = new TypedDocumentString(`
    mutation ReadIdentityProviderByEmail($appClientId: String, $email: String!) {
  __typename
  readIdentityProviderByEmail(appClientId: $appClientId, email: $email) {
    __typename
    identityProviderId
  }
}
    `);

const injectedRtkApi = baseIdentPublicApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    CreateTenant: build.mutation<Types.CreateTenantMutation, Types.CreateTenantMutationVariables>({
      query: (variables) => ({ document: CreateTenantDocument as unknown as string, variables })
    }),
    ConfirmUser: build.mutation<Types.ConfirmUserMutation, Types.ConfirmUserMutationVariables>({
      query: (variables) => ({ document: ConfirmUserDocument as unknown as string, variables })
    }),
    ForgotPassword: build.mutation<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>({
      query: (variables) => ({ document: ForgotPasswordDocument as unknown as string, variables })
    }),
    ReadIdentityProviderByEmail: build.mutation<Types.ReadIdentityProviderByEmailMutation, Types.ReadIdentityProviderByEmailMutationVariables>({
      query: (variables) => ({ document: ReadIdentityProviderByEmailDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateTenantMutation, useConfirmUserMutation, useForgotPasswordMutation, useReadIdentityProviderByEmailMutation } = injectedRtkApi;

